<template>
  <div class="metadata">
    <div class="work-header">
      <h3>{{ authorMetadata.author }}</h3>
      <h4>{{ authorMetadata.authorDateline }}</h4>
      <h2 :lang="$i18n.locale">{{ authorMetadata.title }}</h2>
    </div>
    <p v-html="teaser" />
    <router-link v-if="biographyContentsLength > 1" class="read-more-bio" :to="{ name: 'author-bio', params: {slug: authorSlug }}">{{ $t('readMoreLinkTitle') }}</router-link>
  </div>
</template>

<script>
  import { WORK_SLUG_METADATA_KEY_LOOKUP } from '../constants';

  export default {
    props: ['authorSlug'],
    computed: {
      authorMetadata() {
        const workKey = WORK_SLUG_METADATA_KEY_LOOKUP[this.authorSlug];
        // eslint-disable-next-line vue-i18n/no-dynamic-keys
        return this.$t(workKey);
      },
      biographyContentsLength() {
        return this.authorMetadata.biographyContents.length;
      },
      teaser() {
        const firstContents = this.authorMetadata.biographyContents[0];
        return this.biographyContentsLength > 1 ? `${firstContents}..` : firstContents;
      },
    },
  };
</script>
